import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxSwitch } from '@vertexinc/vtx-ui-react-component-library';
import ColumnSwitchProps from './ColumnSwitchProps.interface';
import './column-switch.scss';
import { GenericGridRowData } from '../../GenericGrid/Interfaces';

const ColumnSwitch = ({
  id,
  checked,
  switchTextChecked,
  switchTextUnchecked,
  onChange,
  row,
  align = 'left',
  useInternalState = true,
  disabled = false,
}: ColumnSwitchProps): JSX.Element => {
  const [switchChecked, setSwitchChecked] = React.useState(null);

  const onChangeSwitch = (rowData: GenericGridRowData): void => {
    if (useInternalState) {
      setSwitchChecked(!switchChecked);
    }

    onChange(rowData);
  };

  // Checked Mode Changed
  React.useEffect(() => {
    setSwitchChecked(checked);
  }, [checked]);

  return (
    <>
      <div key={id} className={`columnSwitch align${align}`}>
        <VtxSwitch checked={switchChecked} onChange={(event) => onChangeSwitch(row)} disabled={disabled} />
        {
          switchTextChecked && switchTextUnchecked
          && (
            <div className="columnSwitchText">
              {switchChecked ? switchTextChecked : switchTextUnchecked}
            </div>
          )
        }
      </div>
    </>
  );
};

export default ColumnSwitch;
